import {
    FaChartLine,
    FaCode,
    FaBullhorn,
    FaRobot
} from "react-icons/fa";


const solutions = [

{
    id:1,
    slug:"digital-strategy",

    icon:<FaChartLine />,

    title:"Digital Strategy & Business Consulting",

    description:
    "Transform your business vision into a scalable digital roadmap. Our experts analyze your goals, market opportunities, and technology requirements to create strategies that improve efficiency and growth.",


    pageDescription:
    "Our Digital Strategy & Business Consulting services help organizations identify growth opportunities, optimize business processes, and create technology strategies aligned with long-term objectives. We combine industry insights, market research, and innovative technologies to help businesses become more agile, competitive, and future-ready.",


    benefits:[
        "Business growth strategy and digital transformation planning",
        "Technology roadmap development aligned with business goals",
        "Process optimization to improve operational efficiency",
        "Data-driven insights for smarter decision making"
    ],


    approach:
    "We analyze your current business challenges, identify improvement areas, and design a customized digital strategy that delivers measurable results.",


    link:"/solutions/digital-strategy"
},



{
    id:2,
    slug:"website-development",

    icon:<FaCode />,

    title:"Website Design & Development",

    description:
    "Create modern, responsive, and high-performing websites that deliver exceptional user experiences and drive business growth.",


    pageDescription:
    "We design and develop powerful digital platforms that help businesses establish a strong online presence. Our websites combine modern UI design, advanced technology, responsive layouts, and optimized performance to deliver seamless experiences across all devices.",


    benefits:[
        "Custom responsive website development",
        "Modern UI/UX focused on user engagement",
        "SEO-friendly and performance optimized architecture",
        "Scalable solutions built for future growth"
    ],


    approach:
    "From design concepts to final deployment, we focus on creating secure, fast, and conversion-driven websites tailored to your business needs.",


    link:"/solutions/website-development"
},



{
    id:3,
    slug:"branding-marketing",

    icon:<FaBullhorn />,

    title:"Branding & Digital Marketing",

    description:
    "Build a strong brand identity with creative strategies and digital marketing solutions.",


    pageDescription:
    "Our Branding and Digital Marketing solutions help businesses create meaningful connections with their audience. We develop strong brand identities, targeted marketing strategies, and digital campaigns that increase visibility, trust, and customer engagement.",


    benefits:[
        "Strategic brand positioning and identity development",
        "Social media and digital marketing campaigns",
        "Content strategies that engage customers",
        "Improved online visibility and brand recognition"
    ],


    approach:
    "We combine creativity, analytics, and marketing expertise to build strategies that strengthen your brand presence and generate business growth.",


    link:"/solutions/branding-marketing"
},



{
    id:4,
    slug:"ai-automation",

    icon:<FaRobot />,

    title:"AI Automation & Solutions",

    description:
    "Implement AI-powered solutions to automate workflows and improve business efficiency.",


    pageDescription:
    "We help businesses leverage Artificial Intelligence to automate repetitive tasks, improve customer experiences, and make smarter decisions. Our AI solutions are designed to increase productivity, reduce operational costs, and create new opportunities for innovation.",


    benefits:[
        "AI-powered workflow automation",
        "Intelligent chatbots and virtual assistants",
        "Advanced data analysis and business insights",
        "Improved productivity and operational efficiency"
    ],


    approach:
    "We identify automation opportunities within your business and implement AI solutions that deliver measurable improvements.",


    link:"/solutions/ai-automation"
}

];


export default solutions;